import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Image = ({ imgName }) => {
  const imageSwitch = name => {
    switch (name) {
      case "eiswagen":
        return (
          <Img
            fixed={data.eiswagen.childImageSharp.fixed}
            fadeIn={false}
            loading="eager"
          />
        )
      case "karussel":
        return (
          <Img
            fluid={data.karussel.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "huepfburg":
        return (
          <Img
            fluid={data.huepfburg.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "popcornmaschine":
        return (
          <Img
            fluid={data.popcornmaschine.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "zirkuszelt":
        return (
          <Img
            fluid={data.zirkuszelt.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "foodtruck":
        return (
          <Img
            fluid={data.foodtruck.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "riesenrad":
        return (
          <Img
            fluid={data.riesenrad.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "fotobox":
        return (
          <Img
            fluid={data.fotobox.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "kinderschminken":
        return (
          <Img
            fluid={data.kinderschminken.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "schiffsbar":
        return (
          <Img
            fluid={data.schiffsbar.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "kaffeewagen":
        return (
          <Img
            fluid={data.kaffeewagen.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "schlittenbahn":
        return (
          <Img
            fluid={data.schlittenbahn.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "gluecksrad":
        return (
          <Img
            fluid={data.gluecksrad.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      case "facebook":
        return (
          <Img
            fluid={data.facebookLogo.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
        )
      default:
        return <p>no image</p>
    }
  }

  const data = useStaticQuery(graphql`
    query {
      eiswagen: file(extension: { eq: "png" }, name: { eq: "eiswagen" }) {
        childImageSharp {
          fixed {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      karussel: file(extension: { eq: "jpg" }, name: { eq: "karussel" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      huepfburg: file(extension: { eq: "jpg" }, name: { eq: "huepfburg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      popcornmaschine: file(
        extension: { eq: "png" }
        name: { eq: "popcornmaschine" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      zirkuszelt: file(extension: { eq: "png" }, name: { eq: "zirkuszelt" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      foodtruck: file(extension: { eq: "png" }, name: { eq: "foodtruck" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      riesenrad: file(extension: { eq: "png" }, name: { eq: "riesenrad" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      fotobox: file(extension: { eq: "jpg" }, name: { eq: "fotobox" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      kinderschminken: file(
        extension: { eq: "png" }
        name: { eq: "kinderschminken" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      schiffsbar: file(extension: { eq: "jpg" }, name: { eq: "schiffsbar" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      kaffeewagen: file(extension: { eq: "png" }, name: { eq: "kaffeewagen" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      schlittenbahn: file(
        extension: { eq: "jpg" }
        name: { eq: "schlittenbahn" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      gluecksrad: file(extension: { eq: "png" }, name: { eq: "gluecksrad" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      facebookLogo: file(relativePath: { eq: "facebook_logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return imageSwitch(imgName)
}

export default Image
